import "./App.css";
import "./styles/mobile-container.css";
import "./styles/footer.css";
import {BrowserRouter, useLocation} from "react-router-dom";
import { AppRoutes } from "./app/routes";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { CampusProvider } from "./context/CampusContext";

function AppContent() {
  const location = useLocation();
  const isDriverPage = location.pathname === '/driver';

  // Clear payment retry state when navigating away from payment flow pages
  const paymentFlowPaths = ['/payment-processing', '/payment-success', '/payment-failure'];
  const isPaymentFlow = paymentFlowPaths.some(p => location.pathname.startsWith(p));

  if (!isPaymentFlow && sessionStorage.getItem('paymentRetryState')) {
    sessionStorage.removeItem('paymentRetryState');
  }

  return (
    <div className={isDriverPage ? "driver-page-wrapper" : "mobile-app-wrapper"}>
      <div className={isDriverPage ? "driver-page-container" : "mobile-app-container"}>
        <AppRoutes />
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <CampusProvider>
            <AppContent />
          </CampusProvider>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
